module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_7016.7a8dff15.png";